import { Injectable } from '@angular/core';
import {Observable} from "rxjs";
import {environment} from "../../environments/environment";
import {map} from "rxjs/operators";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {InterIntegrationConfig} from "../models/inter-integration-config";

@Injectable({
  providedIn: 'root'
})
export class InterBankService {

  constructor(private http: HttpClient) {
  }

  getConfig(): Observable<any> {
    return this.http.get(environment.apiHost + `/secure/inter-bank/config`).pipe(map((response: any) => response.data.integration as InterIntegrationConfig));
  }

  saveConfig(form, fileCrt, fileKey): Observable<any> {
    const formData: FormData = new FormData();
    if(fileCrt) {
      formData.append('crtFile', fileCrt[0]);
    }
    if(fileKey) {
      formData.append('keyFile', fileKey[0]);
    }
    formData.append('integration', new Blob([JSON.stringify(form)], {type: "application/json"}));
    let hd = new HttpHeaders();
    hd = hd.set('Content-Type', 'multipart/form-data');
    const options = {
      headers: hd
    };
    return this.http.put(
        environment.apiHost + '/secure/inter-bank', formData, options).pipe(
        map((response: any) => response.data.integration)
    );
  }
}
